<template lang="pug">
  .cms-partial-wrapper
    .cms-partial(v-if="html")
      component(:is="htmlComponent" v-bind="fullBinding" :client-config="config")
      .cms-inline-style(v-if="css" v-html="cssTag")
    .cms-partial-loader(v-else)
      slot(name="loader")

</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex';

  export default {
    name: "CMSPartial",

    props: {
      mixinKey: {
        type: String,
        default: '',
      },
      initHtml: {
        type: String,
        default: '',
      },
      initCss: {
        type: String,
        default: '',
      },
      config: {
        type: Object,
        default: () => ({})
      }
    },

    computed: {
      ...mapGetters('cms', ['getPartial']),
      ...mapState('global', ['isVueSSRApp']),

      cssTag() {
        const safeCss = String(this.css).replace(/<\/style/gi, '<\\/style');
        const key = this.mixinKey || '';
        return `<style data-cms-key="${key}">${safeCss}</style>`;
      },

      fullBinding() {
        return {
          ...this.$attrs,
          ...this.$props,
        };
      },

      htmlComponent() {
        return {
          template: this.html,
          props: {
            clientConfig: {
              type: Object,
              default: () => ({})
            }
          }
        };
      },

      partial() {
        return this.getPartial(this.mixinKey);
      },

      html() {
        return this.partial?.html || this.initHtml;
      },

      css() {
        return this.partial?.css || this.initCss;
      }
    },

    watch: {
      mixinKey: {
        handler: 'update',
      }
    },

    async created() {
      if (!this.isVueSSRApp || !this.partial) {
        await this.init();
      }
    },

    async serverPrefetch() {
      if (this.isVueSSRApp && !this.partial) {
        await this.init();
      }
    },

    methods: {
      ...mapActions('cms', [
        'loadPartial',
      ]),

      async init() {
        await this.update();
      },

      async update() {
        if (this.mixinKey) {
          await this.loadPartial({ mixinKey: this.mixinKey });
        }
      },
    },
  };
</script>

<style scoped lang="stylus">
</style>
